import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';
import { useContractActions } from '../../context/ContractActionContext';
import { Actions } from '../../stores/ActionStore';


const ReinstatementsTypeInput: InputWithSource = ({ input }) => {
    const contractActions = useContractActions();

    return (
        <GenericSelect
            label={input.name}
            input={input}
            onChange={() => contractActions.dispatch(Actions.RebuildNodes)}
        />
    );
};

ReinstatementsTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ReinstatementsTypeInput);
